module.exports = __webpack_public_path__ + "img/page.faa62e7b.jpg";